import { getLogicGroupConditionsSize, isLogicGroupWithFilterValidationErrors, isLogicGroupWithIncompleteFilters } from '../filterQueryFormat/logic/LogicGroup';
import { useCallback, useContext } from 'react';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
export const usePropertyFilterOnChangeHandler = onChange => {
  const {
    getIsUngated,
    props: {
      strategy
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    unwrapSingleFilter,
    serializer: {
      toFormat
    },
    useHoursFiltering
  } = strategy;
  const handleOnChange = useCallback(newInternalValue => {
    const hasFilters = !!getLogicGroupConditionsSize(newInternalValue);
    const hasIncompleteFilters = hasFilters && isLogicGroupWithIncompleteFilters(newInternalValue, getIsUngated);
    const hasFilterValidationErrors = hasFilters && isLogicGroupWithFilterValidationErrors(newInternalValue);
    let payload = undefined;
    if (!hasIncompleteFilters && !hasFilterValidationErrors) {
      const filterQuery = toFormat(newInternalValue, getIsUngated, {
        useHoursFiltering
      });
      payload = unwrapSingleFilter(
      // @ts-expect-error the unwrap fn is uncallable due to bad types
      filterQuery);
    }
    onChange(
    // @ts-expect-error we know this is `ILSFilter | undefined` for now
    payload, {
      hasIncompleteFilters,
      hasFilterValidationErrors
    });
  }, [getIsUngated, onChange, toFormat, unwrapSingleFilter, useHoursFiltering]);
  return handleOnChange;
};